import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';


export const useSettlementsApi = () => {
    const api = useContext(HimmaContext)!;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getAllSettlements = useCallback(
        async (query: any) => {
            setLoading(true);
            setError(null);
            try {
                // Only include search parameter if it has a value
                const searchParam =
                    query.search && query.search.trim() !== '' ? query.search : undefined;
                const response = await api.getAllSettlements(
                    query.userType,
                    query.page,
                    query.limit,
                    undefined as any,
                    query.transactionType,
                    query.fromDate ? query.fromDate : undefined, // fromDate
                    query.toDate ? query.toDate : undefined, // toDate
                    query.sortBy,
                    query.sortOrder,
                    searchParam,
                    query.settlementUserType,
                    query.settlementUserId,
                    
                );
                return response;
            } catch (err) {
                setError(err instanceof Error ? err.message : 'An error occurred');
                throw err;
            } finally {
                setLoading(false);
            }
        },
        [api]
    );

    return {
        getAllSettlements,
        loading,
        error,
    };
};
